var ColoredChip_types_ChipSize = /*#__PURE__*/ function(ChipSize) {
    ChipSize["large"] = "large";
    ChipSize["medium"] = "medium";
    ChipSize["small"] = "small";
    ChipSize["extraSmall"] = "extraSmall";
    return ChipSize;
}({});
var ColoredChip_types_ChipColor = /*#__PURE__*/ function(ChipColor) {
    ChipColor["gray"] = "gray";
    ChipColor["darkgray"] = "darkgray";
    ChipColor["green"] = "green";
    ChipColor["orange"] = "orange";
    ChipColor["red"] = "red";
    ChipColor["blue"] = "blue";
    ChipColor["purple"] = "purple";
    ChipColor["white"] = "white";
    return ChipColor;
}({});
export { ColoredChip_types_ChipColor as ChipColor, ColoredChip_types_ChipSize as ChipSize };
